import { SchemaColumnOptions, SchemaTableOptions } from "@/vendors/prx-sqlite/Interfaces/SchemaInterfaces";

export const telcpu_locations:SchemaTableOptions = {
    name:<string> 'telcpu_locations',
    schema:<Array<SchemaColumnOptions>> [
        { column: 'id', value: 'INTEGER PRIMARY KEY AUTOINCREMENT'},
        { column: 'name', value: 'VARCHAR(255) NOT NULL'},
    ]
}